import React from 'react';
import { Play, SkipBack, SkipForward } from 'lucide-react';
import { Card } from '../ui/Card';
import { cn } from '../ui/Button';
import { useTheme } from '../../hooks/useTheme';
export function TimelineControls() {
  const {
    theme
  } = useTheme();
  const isLight = theme === 'light';
  const dates = Array.from({
    length: 21
  }, (_, i) => {
    const d = new Date(2026, 1, 12 + i);
    return {
      day: d.getDate(),
      month: d.toLocaleString('default', {
        month: 'short'
      }).toUpperCase(),
      active: i === 0
    };
  });
  return <div className="absolute bottom-6 left-6 right-6 z-[1000] flex items-end gap-4" data-id="element-1025">
      {/* Controls */}
      <Card className={cn('flex items-center gap-1 p-2 backdrop-blur border rounded-lg', isLight ? 'bg-white/90 border-slate-200 shadow-lg shadow-slate-200/50' : 'bg-[#111827]/90 border-slate-700/50')} data-id="element-1026">
        <button className={cn('p-2 rounded-md transition-colors', isLight ? 'text-slate-400 hover:text-slate-700 hover:bg-slate-100' : 'text-slate-400 hover:text-white hover:bg-slate-800')} data-id="element-1027">
          <SkipBack size={16} data-id="element-1028" />
        </button>
        <button className={cn('p-2 rounded-md transition-colors', isLight ? 'text-[#EC4899] bg-[#EC4899]/10 hover:bg-[#EC4899]/20' : 'text-white bg-slate-700 hover:bg-slate-600')} data-id="element-1029">
          <Play size={16} fill="currentColor" data-id="element-1030" />
        </button>
        <button className={cn('p-2 rounded-md transition-colors', isLight ? 'text-slate-400 hover:text-slate-700 hover:bg-slate-100' : 'text-slate-400 hover:text-white hover:bg-slate-800')} data-id="element-1031">
          <SkipForward size={16} data-id="element-1032" />
        </button>
      </Card>

      {/* Current Time Pill */}
      <div className="absolute bottom-20 left-1/2 -translate-x-1/2" data-id="element-1033">
        <div className={cn('flex items-center gap-2 px-3 py-1.5 rounded-full border text-xs font-mono shadow-lg backdrop-blur', isLight ? 'bg-white/90 border-slate-200 text-slate-700' : 'bg-[#111827]/90 border-slate-700/50 text-slate-200')} data-id="element-1034">
          <span data-id="element-1035">Feb 12, 02:00 AM</span>
          <span className="h-2 w-2 rounded-full bg-[#EC4899] animate-pulse" data-id="element-1036" />
        </div>
      </div>

      {/* Timeline Scrubber */}
      <Card className={cn('flex-1 h-14 backdrop-blur border flex items-center px-4 overflow-hidden relative', isLight ? 'bg-white/90 border-slate-200 shadow-lg shadow-slate-200/50' : 'bg-[#111827]/90 border-slate-700/50')} data-id="element-1037">
        {/* Progress Line */}
        <div className="absolute top-0 bottom-0 left-[18px] w-0.5 bg-[#EC4899] z-10" data-id="element-1038">
          <div className="absolute top-0 -left-[3px] w-2 h-2 rounded-full bg-[#EC4899]" data-id="element-1039" />
        </div>

        <div className="flex items-center justify-between w-full pl-6" data-id="element-1040">
          {dates.map((date, i) => <div key={i} className="flex flex-col items-center gap-1 min-w-[32px] cursor-pointer group" data-id="element-1041">
              <div className={cn('h-2 w-0.5 rounded-full transition-colors', date.active ? 'bg-[#EC4899] h-3' : isLight ? 'bg-slate-300 group-hover:bg-slate-400' : 'bg-slate-700 group-hover:bg-slate-500')} data-id="element-1042" />
              <span className={cn('text-[10px] font-medium leading-none', date.active ? isLight ? 'text-slate-900' : 'text-white' : isLight ? 'text-slate-400 group-hover:text-slate-600' : 'text-slate-500 group-hover:text-slate-400')} data-id="element-1043">
                {date.day}
              </span>
              <span className={cn('text-[8px] leading-none', isLight ? 'text-slate-400' : 'text-slate-600')} data-id="element-1044">
                {date.month}
              </span>
            </div>)}
        </div>
      </Card>
    </div>;
}